"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFeedbackCloseClick = void 0;
var tslib_1 = require("tslib");
var bi_logger_1 = require("./bi-logger");
// TODO move tracking to client.
exports.trackFeedbackCloseClick = function (defaultParams) { return function (pageName) {
    if (!defaultParams) {
        return;
    }
    // tslint:disable-next-line no-floating-promises
    bi_logger_1.biLogger.log(tslib_1.__assign(tslib_1.__assign({}, defaultParams), { pageName: pageName, evid: 803 }));
}; };
//# sourceMappingURL=track-feedback-close-click.js.map